import axios from "axios";
import { removeAuth } from "../helpers/auth";
import { defaultConfig } from "../config";
import { ErrorMessage } from "../helpers/common";

const axiosInt = axios.create({
  baseURL: defaultConfig.baseAPIUrl,
});

let code = null;
try {
  code = JSON.parse(localStorage.getItem("code") || "null");
} catch {
  code = null;
}

axiosInt.interceptors.response.use(
  (response) => {
    if (response.data.message === "Tenant not found.") {
      removeAuth();
      window.location.href = `/${code || "admin"}`;
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      removeAuth();
      window.location.href = `/${code || "admin"}`;
    }
    if (error?.response?.status === 403) {
      ErrorMessage("You do not have permission!");
      setTimeout(() => {
        window.location.href = "/dashboard";
      }, 2000);
    } else if (error?.response?.status === 400) {
      const fieldErrors = error?.response?.data?.errors;
      if (fieldErrors && typeof fieldErrors === "object") {
        const allErrors = Object.entries(fieldErrors).flatMap(
          ([field, messages]) =>
            (Array.isArray(messages) ? messages : [messages]).map(
              (msg) => `${field}:${msg}`
            )
        );
        ErrorMessage(allErrors[0] || error?.response?.data?.title || "Request failed.");
      } else {
        ErrorMessage(
          error?.response?.data?.message ||
            error?.response?.data?.title ||
            error?.message ||
            "Request failed."
        );
      }
    } else {
      ErrorMessage(error?.message || "Request failed.");
    }
    return Promise.reject(error);
  }
);

export default axiosInt;
